var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 28,
    viewBox: "0 96 960 960",
    width: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M810.898 952Q681 952 554.5 890 428 828 328 728T166 501q-62-127-62-256.898 0-20.388 12.357-32.745Q128.714 199 149 199h159q13.243 0 24.648 10T347 234l29 141q2 14-1 25.5t-9 17.5L262 524q53 89 122.5 158T536 797l103-104q9-10 19.977-14 10.976-4 22.023-1l139 31q14.875 3.375 25.438 15.688Q856 737 856 752v155q0 20.286-12.357 32.643T810.898 952ZM226 457l77-78-23.01-107H179q0 39 11 83t36 102Zm379 376q40 19 86.5 30.5T783 878v.5V775l-103-22-75 80ZM226 457Zm379 376Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumber);
export default __webpack_public_path__ + "static/media/phoneNumber.88498622bddb32304433362a942864c5.svg";
export { ForwardRef as ReactComponent };